import { useEffect } from "react";

/**
 * SSO handoff shim.
 *
 * The Apex marketing app links users to https://<this-app>/sso?token=<jwt>.
 * The k8s ingress routes non-/api paths to the React SPA, so we can't put the
 * validation directly at /sso on the backend. This component preserves the
 * query string and forwards the browser (top-level navigation) to
 * /api/sso?token=..., where the FastAPI endpoint decodes the JWT, sets auth
 * cookies, and 303-redirects to /admin or /portal (or /login?error=invalid_sso
 * on failure).
 */
export default function SsoHandoff() {
  useEffect(() => {
    const search = window.location.search || "";
    window.location.replace(`/api/sso${search}`);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center text-zinc-500 mono-label"
      data-testid="sso-handoff"
    >
      Signing you in&hellip;
    </div>
  );
}
